import {
    IMG_7574,
    IMG_7575,
    IMG_7576,
    IMG_7577,
    IMG_7595,
    IMG_7596,
    IMG_7600,
    IMG_7605,
    IMG_7611,
    IMG_7614
} from 'utils/assets/images';
import { find } from 'lodash';
import nonotificationJson from './lottie/nonotification.json';
import elephantJson from './lottie/elephant.json';
export const AVATARS = {
    IMG_7614,
    IMG_7611,
    IMG_7605,
    IMG_7600,
    IMG_7574,
    IMG_7575,
    IMG_7576,
    IMG_7577,
    IMG_7595,
    IMG_7596
}
const getFireStoreUrl = (path) => (`https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/lottie%2F${path}?alt=media&token=3c93afc3-5138-43da-98fd-e35987d9c6c4`);
const getFireStoreWebmUrl = (path) => (`https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/lottie%2Fwebp%2F${path}?alt=media&token=9191c88b-b992-4d55-9ba9-54d3c5c102c3`);
export const PROFILE_AVATARS_LOTTIE = [
    {
        poster: getFireStoreWebmUrl("BlueMonsterdata.webm"),
        thumbnail: "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/lootie-animation%2F1.png?alt=media&token=e2a16008-ede0-43d8-bca8-c9b2783d7dd7",
        key: 'BlueMonsterdata'
    },
    {
        poster: getFireStoreWebmUrl("GradientMonster2data.webm"),
        thumbnail: "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/lootie-animation%2F2.png?alt=media&token=1ef9cab0-cb88-481d-8e21-a933685bbac7",
        key: 'GradientMonster2data'
    },
    {
        poster: getFireStoreWebmUrl("GradientMonsterdata.webm"),
        thumbnail: "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/lootie-animation%2F3.png?alt=media&token=1ef9cab0-cb88-481d-8e21-a933685bbac7",
        key: 'GradientMonsterdata'
    },
    {
        poster: getFireStoreWebmUrl("GreenMonsterdata.webm"),
        thumbnail: "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/lootie-animation%2F4.png?alt=media&token=1ef9cab0-cb88-481d-8e21-a933685bbac7",
        key: 'GreenMonsterdata'
    },
    {
        poster: getFireStoreWebmUrl("LimeMonsterdata.webm"),
        thumbnail: "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/lootie-animation%2F5.png?alt=media&token=1ef9cab0-cb88-481d-8e21-a933685bbac7",
        key: 'LimeMonsterdata'
    },
    {
        poster: getFireStoreWebmUrl("OrangeMonsterdata.webm"),
        thumbnail: "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/lootie-animation%2F6.png?alt=media&token=1ef9cab0-cb88-481d-8e21-a933685bbac7",
        key: 'OrangeMonsterdata'
    },
    {
        poster: getFireStoreWebmUrl("PinkMonsterdata.webm"),
        thumbnail: "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/lootie-animation%2F7.png?alt=media&token=1ef9cab0-cb88-481d-8e21-a933685bbac7",
        key: 'PinkMonsterdata'
    },

    {
        poster: getFireStoreWebmUrl("PurpleMonsterdata.webm"),
        thumbnail: "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/lootie-animation%2F8.png?alt=media&token=1ef9cab0-cb88-481d-8e21-a933685bbac7",
        key: 'PurpleMonsterdata'
    },
    {
        poster: getFireStoreWebmUrl("redmonster2data.webm"),
        thumbnail: "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/lootie-animation%2F12.png?alt=media&token=1ef9cab0-cb88-481d-8e21-a933685bbac7",
        key: 'redmonster2data'
    },
    {
        poster: getFireStoreWebmUrl("SkyBlueMonsterdata.webm"),
        thumbnail: "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/lootie-animation%2F9.png?alt=media&token=1ef9cab0-cb88-481d-8e21-a933685bbac7",
        key: 'SkyBlueMonsterdata'
    },
    {
        poster: getFireStoreWebmUrl("Teal_Monster2data.webm"),
        thumbnail: "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/lootie-animation%2F10.png?alt=media&token=9303f6a2-63f2-45b4-88f6-3df5c775d28f",
        key: 'TealMonster2data'
    },
    {
        poster: getFireStoreWebmUrl("YellowMonsterdata.webm"),
        thumbnail: "https://firebasestorage.googleapis.com/v0/b/yo-americano.appspot.com/o/lootie-animation%2F11.png?alt=media&token=1ef9cab0-cb88-481d-8e21-a933685bbac7",
        key: 'YellowMonsterdata'
    },
    {
        poster: getFireStoreWebmUrl("Gray-monster.webm"),
        thumbnail: "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/2ae321e4-01fb-4663-d8df-f2dade95d800/thumbnail",
        key: 'greyMonsterdata'
    },
    {
        poster: getFireStoreWebmUrl("PurpleCrabdata.webm"),
        thumbnail: "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/710f4ac1-1e17-4411-ac1e-ae502ffdb200/thumbnail",
        key: 'purpleCrabdata'
    },
    {
        poster: getFireStoreWebmUrl("Pink-monster.webm"),
        thumbnail: "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/96c7b011-b8c6-4dab-1525-f2e088480b00/thumbnail",
        key: 'pinkTeethdata'
    },
    {
        poster: getFireStoreWebmUrl("PurpleBigEyedata.webm"),
        thumbnail: "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/e5de4299-9118-4fe1-475d-95878515f900/thumbnail",
        key: 'purpleBigEyedata'
    },
    {
        poster: getFireStoreWebmUrl("BlueTwoTeethdata.webm"),
        thumbnail: "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/056c7e74-c7aa-4bb7-142b-570aeae23700/thumbnail",
        key: 'blueTwoTeethdata'
    },
    {
        poster: getFireStoreWebmUrl("Lime-monster.webm"),
        thumbnail: "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/e28afebd-27ac-48ab-fc19-8ce9a17fbf00/thumbnail",
        key: 'greenOneEyedata'
    },
    {
        poster: getFireStoreWebmUrl("YellowSinglePiecedata.webm"),
        thumbnail: "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/4d5c7fa3-e50d-40a8-b75d-faf3c3417a00/thumbnail",
        key: 'yellowSinglePiecedata'
    },
    {
        poster: getFireStoreWebmUrl("PurpleDevilOnHeaddata.webm"),
        thumbnail: "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/b6b115fb-8000-4bdf-d1ed-a6324cfea000/thumbnail",
        key: 'purpleDevilOnHeaddata'
    },
    {
        poster: getFireStoreWebmUrl("Snugglehorndata.webm"),
        thumbnail: "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/e3e48ec6-f1bd-4c2a-e5e1-348c6e146800/thumbnail",
        key: 'snugglehorndata'
    },
    {
        poster: getFireStoreWebmUrl("MultipleEyeMonsterdata.webm"),
        thumbnail: "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/6fefa266-bc1c-4749-5a01-6e5d1c0a5500/thumbnail",
        key: 'multipleEyeMonsterdata'
    },
    {
        poster: getFireStoreWebmUrl("Sky-Blue-monster.webm"),
        thumbnail: "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/9d7d468c-3126-4b0c-bc57-ee554d217e00/thumbnail",
        key: 'blueNoEyeWithFootdata'
    },
    {
        poster: getFireStoreWebmUrl("Blinkodata.webm"),
        thumbnail: "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/d68a88a5-040b-4b3b-88d6-b5b63a159800/thumbnail",
        key: 'blinkodata'
    },
    {
        poster: getFireStoreWebmUrl("Triclopsadata.webm"),
        thumbnail: "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/faaee4e8-5202-4352-2f6e-b44e614cfd00/thumbnail",
        key: 'triclopsadata'
    },
    {
        poster: getFireStoreWebmUrl("Gaspuffdata.webm"),
        thumbnail: "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/584ad4cb-21fa-4caf-636c-66d81cb44600/thumbnail",
        key: 'gaspuffdata'
    },
    {
        poster: getFireStoreWebmUrl("TonglumpdataNew.webm"),
        thumbnail: "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/08685c7c-6480-4b46-cb07-b5ee80094f00/thumbnail",
        key: 'tonglumpdata'
    },
    {
        poster: getFireStoreWebmUrl("Blinkzoiddata.webm"),
        thumbnail: "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/99d6012a-e53e-4cbf-a1af-f8d5dd866b00/thumbnail",
        key: 'blinkzoiddata'
    },
    {
        poster: getFireStoreWebmUrl("Blorbothetoastydata.webm"),
        thumbnail: "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/f0e2b775-a3ad-4e1a-f00f-a8c05118d200/thumbnail",
        key: 'blorbothetoastydata'
    },
    {
        poster: getFireStoreWebmUrl("Greenfattydata.webm"),
        thumbnail: "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/d62c70bc-dbba-4960-454e-34c573184100/thumbnail",
        key: 'greenfattydata'
    },
    {
        poster: getFireStoreWebmUrl("happyDevilGreendata.webm"),
        thumbnail: "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/6771061f-734d-498d-ae37-65f4c3a5cb00/thumbnail",
        key: 'happyDevilGreendata'
    },
    {
        poster: getFireStoreWebmUrl("Orangethreeteethdata.webm"),
        thumbnail: "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/f0d4eaa0-3b65-4cb5-1479-bc8bef84c600/thumbnail",
        key: 'orangethreeteethdata'
    },
    {
        poster: getFireStoreWebmUrl("Nolegmonsterdata.webm"),
        thumbnail: "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/5df03c8a-3c25-4e2a-56a4-52bdced59700/thumbnail",
        key: 'nolegmonsterdata'
    },
    {
        poster: getFireStoreWebmUrl("Greenbecteriadata.webm"),
        thumbnail: "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/8d42f2c4-39d0-4e07-eeba-40b645b0f300/thumbnail",
        key: 'greenbecteriadata'
    },
    {
        poster: getFireStoreWebmUrl("Lightgreentrumplinedata.webm"),
        thumbnail: "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/8de0ea4b-2af7-4b4e-fbde-ee0718b32600/thumbnail",
        key: 'lightgreentrumplinedata'
    },
    {
        poster: getFireStoreWebmUrl("Bigmouththreeeyedata.webm"),
        thumbnail: "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/aee8bd9f-de2d-4798-c987-57a96ac86c00/thumbnail",
        key: 'bigmouththreeeyedata'
    },
    {
        poster: getFireStoreWebmUrl("Purplepgnosedata.webm"),
        thumbnail: "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/95a567ee-85ea-418a-38c5-5468f31c5400/thumbnail",
        key: 'purplepgnosedata'
    },
    {
        poster: getFireStoreWebmUrl("Bigeyebignoseantdata.webm"),
        thumbnail: "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/927a1e4d-d5be-43f3-801a-496a63efad00/thumbnail",
        key: 'bigeyebignoseantdata'
    },
    {
        poster: getFireStoreWebmUrl("Yellowfullfacedata.webm"),
        thumbnail: "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/4d33d5d5-c6de-4713-cef7-e4312391ae00/thumbnail",
        key: 'yellowfullfacedata'
    },
    {
        poster: getFireStoreWebmUrl("Redmonsterwithpentsdata.webm"),
        thumbnail: "https://imagedelivery.net/B62pqpMZqieDKhv80nP5iw/2806f3d4-e57b-497e-1f55-edd1d4845900/thumbnail",
        key: 'redmonsterwithpentsdata'
    }
]

export const NOTIFICATIONICONS = {
    poster: nonotificationJson
};
export const ELEPHANT = {
    poster: elephantJson
};



export const getAvatar = (avatar) => {
    if (avatar) {
        const file_data = find(PROFILE_AVATARS_LOTTIE, ["key", avatar]);
        if (file_data) return file_data.thumbnail
        else if (AVATARS[avatar]) {
            return AVATARS[avatar]
        }
        return null;
    }
}